/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Items_Tabs_ImagesInputs */

const id_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gambar`)
};

const ms_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imej`)
};

const da_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billeder`)
};

const de_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder`)
};

const en_us2_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images`)
};

const es_es2_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imágenes`)
};

const es_mx2_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imágenes`)
};

const fil_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Larawan`)
};

const fr_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Images`)
};

const it_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Immagini`)
};

const hu_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Képek`)
};

const nl_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afbeeldingen`)
};

const no_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder`)
};

const pl_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrazy`)
};

const pt_br2_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagens`)
};

const pt_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagens`)
};

const ro_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Imagini`)
};

const fi_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuvat`)
};

const sv_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bilder`)
};

const vi_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hình ảnh`)
};

const tr_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Görseller`)
};

const cs_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Obrázky`)
};

const bg_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изображения`)
};

const ru_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Изображения`)
};

const uk_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зображення`)
};

const ar_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الصور`)
};

const hi_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`छवियाँ`)
};

const th_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รูปภาพ`)
};

const ja_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画像`)
};

const zh_cn2_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`图像`)
};

const zh_hant1_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圖像`)
};

const ko_items_tabs_images = /** @type {(inputs: Items_Tabs_ImagesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미지`)
};

/**
* | output |
* | --- |
* | "Images" |
*
* @param {Items_Tabs_ImagesInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const items_tabs_images = /** @type {((inputs?: Items_Tabs_ImagesInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Items_Tabs_ImagesInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_items_tabs_images(inputs)
	if (locale === "ms") return ms_items_tabs_images(inputs)
	if (locale === "da") return da_items_tabs_images(inputs)
	if (locale === "de") return de_items_tabs_images(inputs)
	if (locale === "en-US") return en_us2_items_tabs_images(inputs)
	if (locale === "es-ES") return es_es2_items_tabs_images(inputs)
	if (locale === "es-MX") return es_mx2_items_tabs_images(inputs)
	if (locale === "fil") return fil_items_tabs_images(inputs)
	if (locale === "fr") return fr_items_tabs_images(inputs)
	if (locale === "it") return it_items_tabs_images(inputs)
	if (locale === "hu") return hu_items_tabs_images(inputs)
	if (locale === "nl") return nl_items_tabs_images(inputs)
	if (locale === "no") return no_items_tabs_images(inputs)
	if (locale === "pl") return pl_items_tabs_images(inputs)
	if (locale === "pt-BR") return pt_br2_items_tabs_images(inputs)
	if (locale === "pt") return pt_items_tabs_images(inputs)
	if (locale === "ro") return ro_items_tabs_images(inputs)
	if (locale === "fi") return fi_items_tabs_images(inputs)
	if (locale === "sv") return sv_items_tabs_images(inputs)
	if (locale === "vi") return vi_items_tabs_images(inputs)
	if (locale === "tr") return tr_items_tabs_images(inputs)
	if (locale === "cs") return cs_items_tabs_images(inputs)
	if (locale === "bg") return bg_items_tabs_images(inputs)
	if (locale === "ru") return ru_items_tabs_images(inputs)
	if (locale === "uk") return uk_items_tabs_images(inputs)
	if (locale === "ar") return ar_items_tabs_images(inputs)
	if (locale === "hi") return hi_items_tabs_images(inputs)
	if (locale === "th") return th_items_tabs_images(inputs)
	if (locale === "ja") return ja_items_tabs_images(inputs)
	if (locale === "zh-CN") return zh_cn2_items_tabs_images(inputs)
	if (locale === "zh-Hant") return zh_hant1_items_tabs_images(inputs)
	return ko_items_tabs_images(inputs)
});
export { items_tabs_images as "items.tabs.images" }